import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PagedAuditResponse } from './+models/audit-log.model';
import {
  SimulatedFlightSkeleton,
  PagedSimulatedFlightAudit
} from './+models/simulated-flight.audit.model';

@Injectable()
export class SimulatedFlightAuditService {
  private readonly apiUrl = '/sdapi/post-flight/PostedFlightAudit';

  constructor(private readonly http: HttpClient) {}

  getSimulatedFlightSkeletons(crewMemberId: number) {
    return this.http.get<SimulatedFlightSkeleton[]>(
      `${this.apiUrl}/SimulatedFlightSkeletons/${crewMemberId}`
    );
  }

  getSimulatedFlightAudit(
    simulatedFlightId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    return this.getAuditPage<PagedSimulatedFlightAudit>(
      `SimulatedFlight/${simulatedFlightId}`,
      pageNumber,
      pageSize,
      lastAuditLogId
    );
  }

  private getAuditPage<T extends PagedAuditResponse>(
    subRoute: string,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 10;
    }
    let url = `${this.apiUrl}/${subRoute}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }

    return this.http.get<T>(url);
  }
}
